





















































import LandingHeader from '@/components/LandingHeaderB.vue';
import { Loading, Logo } from '@/components/ds';
import Vue from 'vue';

import accountsIframe, {
  AccountsPages,
  LoginWithIframeData,
  ProductName,
  SignMethods,
} from '@/helpers/accountsIframe';
import Analytics from '@/helpers/analytics/analytics';
import { SignUpMethod } from '@/helpers/westeros';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import { UserInfo } from '@/store/modules/user/state';
import VueMarkdown from 'vue-markdown';

declare module 'vue/types/vue' {
  interface Vue {
    isLoading: Boolean;
  }
}

interface IInitAdmissionUser {
  name?: string;
  email?: string;
  phone?: string;
  accountId?: number;
}

export default Vue.extend({
  components: {
    LandingHeader,
    VueMarkdown,
    Loading,
    Logo,
  },
  data() {
    return { isLoading: false };
  },
  computed: {
    isLoggedInAccounts(): boolean {
      return accountsIframe.isLogged();
    },
    tokenD(): string | undefined {
      return accountsIframe.getTokenD();
    },
    profileName(): string | undefined {
      return accountsIframe.getProfileName();
    },
    isFullyLogged(): boolean | undefined {
      return !!(this.isLoggedInAccounts && this.tokenD && this.profileName);
    },
    userFromStore(): UserInfo {
      return this.$store.getters.user;
    },
    isLoginSuccess(): boolean | undefined {
      return this.$store.getters.isLoginSuccess;
    },
  },
  mounted() {
    this.getAccountsInfo();

    this.loadAccountsAsIframe();
  },
  methods: {
    loadAccountsAsIframe(): void {
      const accountsUrl = `${process.env.VUE_APP_ACCOUNTS_URL}/${
        this.isLoggedInAccounts
          ? AccountsPages.COMPLETE_REGISTRATION
          : AccountsPages.COMPLETE_SIGN_UP
      }`;

      const params: LoginWithIframeData = {
        url: accountsUrl,
        productName: ProductName.UNDERGRAD_DESCOMPLICA,
        hideHeaders: true,
        hideFooter: false,
        hideSocialMedia: false,
        onSuccess: this.iframeOnSuccess,
      };

      accountsIframe.loginWithIframe(
        params,
        '.sign-up__iframe__iframe-container',
        'sign-up__iframe__iframe-container__accounts-iframe',
      );
    },
    async iframeOnSuccess(): Promise<void> {
      try {
        this.isLoading = true;
        this.getAccountsInfo();

        const user = this.userFromStore;
        const { name, email, phone } = user;
        const { signMethod, id } = accountsIframe.getPocketProfile() || {};
        const pocketTokenD = accountsIframe.getTokenD();

        try {
          await this.$store.dispatch('GET_USER', {
            name,
            email,
            phone,
            signMethod: SignUpMethod.accounts,
          });

          await this.startExistentUser({ name, email });
          return;
        } catch (error) {
          // suppress error
        }

        await this.initDexUser({ tokenD: pocketTokenD });

        if (signMethod === SignMethods.SIGN_UP || signMethod === SignMethods.COMPLETED_PROFILE) {
          await this.initAdmissionsUser({
            name,
            email,
            phone,
            accountId: id,
          });
          return;
        }
        this.$emit('forceRerender');
      } catch (error) {
        // supress error
      } finally {
        this.isLoading = false;
      }
    },
    async initAdmissionsUser({ name, email, phone, accountId }: IInitAdmissionUser): Promise<void> {
      await this.$store.dispatch('UPSERT_USER', {
        user: {
          name,
          accountId,
          email,
          phone,
          signupMethod: SignUpMethod.accounts,
        },
      });

      await this.startExistentUser({ name, email });
    },
    async initDexUser(payload: { tokenD?: string }): Promise<void> {
      if (!payload.tokenD) return;

      try {
        await this.$store.dispatch('GET_OR_CREATE_DEX_USER', payload);
      } catch (error) {
        // suppress error
      }
    },
    async startExistentUser({
      name,
      email,
    }: {
      name?: string | undefined;
      email?: string | undefined;
    }): Promise<void> {
      const pocketProfile = accountsIframe.getPocketProfile();
      await this.$store.dispatch('CREATE_AUTH_TOKEN');
      if (pocketProfile) {
        const accountId = pocketProfile.id.toString();
        Analytics.identify({ id: accountId, email, name });
        window.POCKET.alias(email || accountId);
      }

      if (this.isLoginSuccess) {
        try {
          await this.$store.dispatch('PULL_CURRENT_ADMISSION');
        } catch {
          await this.$store.dispatch('CREATE_NEW_ADMISSION');
          await this.$store.dispatch(AnalyticsActions.SUBSCRIPTION_COMPLETED);
          Analytics.trackFirstAccess();
        }
      }

      await this.$store.dispatch('PULL_PIPELINE');
      await this.$store.dispatch('START_PIPELINE');
    },
    async getAccountsInfo(): Promise<void> {
      const tokenD = accountsIframe.getTokenD();

      if (tokenD) {
        const pocketProfile = accountsIframe.getPocketProfile();

        if (pocketProfile) {
          const { name, phone, email } = pocketProfile;

          this.$store.commit('SET_USER', {
            name,
            email,
            phone,
            signupMethod: SignUpMethod.accounts,
          });
        }
      }
    },
    handleSignOut(): void {
      accountsIframe.logout();
      this.$emit('forceRerender');
    },
  },
});
